
export default {
    layout: "only-content",
    components: {
        balance: () => import('../../components/payment/balance.vue')
    }
};
